import { render } from "./FocusIcon.vue?vue&type=template&id=1b18abe0"
import script from "./FocusIcon.vue?vue&type=script&lang=js"
export * from "./FocusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__